/* eslint-disable camelcase */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import ExpError from '@/modules/FPKG-20000-Util/library/ExpError';
import $http, { options } from '../prototypes/axios';

const authorization = localStorage.getItem('x-authorisation');
const setting: AxiosRequestConfig = JSON.parse(JSON.stringify(options));

setting.headers['Content-Type'] = 'multipart/form-data';
setting.headers['x-authorisation'] = authorization;
setting.withCredentials = true;
setting.method = 'post';

class FileUploader {
  private url: string = ''; // 上傳的目標 url 路徑

  private uploadConfig: AxiosRequestConfig = setting; // 圖片上傳功能的特別設定

  private queue: AxiosInstance[] = [];

  constructor(url: string) {
    this.url = url;
  }

  /**
   * setFileQuee
   */
  public setFileQuee(queue: any): void {
    this.queue = queue;
  }

  public parseFile(files: File[], inputKey: string): this {
    try {
      if (!this.url || !this.uploadConfig) {
        throw new ExpError('Uplading URL and InputKeyID is missing', 20001);
      }

      const queue = files.map((img: File) => {
        const formData = new FormData();
        formData.append(inputKey, img);
        return $http.post(this.url, formData, this.uploadConfig);
      });

      this.setFileQuee(queue);
      return this;
    } catch (error) {
      throw error;
    }
  }

  /**
   * upload
   */
  public async upload(): Promise<AxiosResponse[]> {
    return axios.all(this.queue)
      /** 這邊 response 元廠定義有誤，只好用 any 佔位避免出錯 */
      .then((response: any[]) => {
        const successFiles: any = response.filter((x: any) => x.data.code === 0);
        return successFiles;
      })
      .catch(() => {
        throw new ExpError('Some Error causing when data response', 20002);
      });
  }
}

export default FileUploader;


// private uploadResponse: any = []; //
// const self = this;
// self.uploadResponse = response;
/** 取得結果或列印空白 */
// public get getUpload() {
//   return this.uploadResponse;
// }
